import { styled as y, Box as k } from "@mui/material";
import E from "../../../assets/icons/icon-tick.svg.js";
import _ from "../generic/SearchEmptyState.js";
import { LOADING_DISMISS_DELAY as z } from "../../../constants/dataGrid.js";
import { DEFAULT_LIST_SIZE as F } from "../../../constants/layout.js";
import V from "../../../hooks/generic/useCSR.js";
import H from "../../../../ui-lib/components/ApeironLoadingNow.js";
import { AgGridReact as M } from "ag-grid-react";
import * as d from "ramda";
import { useState as B, useCallback as r, useImperativeHandle as $ } from "react";
import { useTranslation as q } from "react-i18next";
import { jsx as n, Fragment as W } from "react/jsx-runtime";
const Y = y(k)`
  width: 100%;
  height: 460px;

  .Custom-Grid {
    border-radius: 10px;
    overflow: hidden;
    .custom-ag-cell-left {
      justify-content: flex-start;
    }
    .custom-ag-cell-center {
      justify-content: center;
    }
    .custom-ag-cell-right {
      justify-content: flex-end;
    }
    .custom-ag-header-left {
      .ag-header-cell-label {
        justify-content: flex-start;
      }
    }
    .custom-ag-header-left {
      .ag-header-cell-label {
        justify-content: flex-start;
      }
    }
    .custom-ag-header-center {
      .ag-header-cell-label {
        justify-content: center;
      }
    }
    .custom-ag-header-right {
      .ag-header-cell-label {
        justify-content: flex-end;
      }
    }
    .ag-row-hover {
      background-color: #222225;
    }
    .ag-header {
      font-size: 16px;
    }
    .ag-header-row {
      background-color: #27272a;
    }
    .ag-body-viewport {
      background-color: #0e0e12;
    }
    .ag-cell {
      display: flex;
      align-items: center;
    }
    .ag-checkbox-input-wrapper.ag-checked {
      --background-color: #005bd7;
      --border-color: #005bd7;
    }
    .ag-checkbox-input-wrapper {
      --background-color: #363636;
      --border-color: #7a7979;
      aspect-ratio: 1;
      width: 18px;
    }
    .ag-checkbox-input-wrapper::after {
      content: '';
      aspect-ratio: 1;
      background: var(--background-color);
      border-radius: 4px;
      border: 1px solid var(--border-color);
      display: flex;
      justify-content: center;
      pointer-events: none;
      width: 18px;
    }
    .ag-checkbox-input-wrapper.ag-checked::after {
      content: url(${`"${E}"`});
    }
  }
`, Z = y(k)`
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
`, le = (v) => {
  const {
    autoFetch: u = !0,
    className: D,
    defaultColDef: p,
    emptyConfig: e,
    gridRef: O,
    pageSize: l = F,
    selectionColumnDef: f,
    fetch: h,
    ...S
  } = v, {
    t: m
  } = q(), [o, C] = B(null), G = {
    lockVisible: !0,
    sortable: !1,
    suppressMovable: !0,
    resizable: !1
  }, L = {
    maxWidth: 0
  }, j = V(), s = r((t) => {
    const a = {
      rowCount: void 0,
      getRows: async (x) => {
        const {
          startRow: c,
          endRow: R
        } = x;
        t.setGridOption("loading", !0);
        const {
          data: i,
          total: T = i.length < R - c ? i.length + c : R
        } = await h(c / l + 1, l);
        c === 0 && d.isEmpty(i) ? setTimeout(() => t.showNoRowsOverlay(), z) : t.hideOverlay(), t.setGridOption("loading", !1), x.successCallback(i, T);
      }
    };
    t.setGridOption("datasource", a);
  }, [h, l]), A = r(async (t) => {
    const {
      api: a
    } = t;
    a && (u && s(a), C(a));
  }, [u, s]), N = r(() => /* @__PURE__ */ n(Z, {
    children: /* @__PURE__ */ n(H, {})
  }), []), I = r(() => /* @__PURE__ */ n(_, {
    buyURL: e == null ? void 0 : e.emporiumURL,
    rentURL: e == null ? void 0 : e.lootRushURL,
    description: m("common.no_data")
  }), [e == null ? void 0 : e.emporiumURL, e == null ? void 0 : e.lootRushURL, m]), U = r(function(t) {
    return t.data.id;
  }, []), g = r((t, a) => {
    o && o.setColumnsVisible([t], a);
  }, [o]), b = r(() => {
    o && s(o);
  }, [o, s]), w = r(() => {
    o && o.deselectAll();
  }, [o]);
  return $(O, () => ({
    deselectAll: w,
    setColumnVisible: g,
    refreshData: b
  }), [w, b, g]), j ? /* @__PURE__ */ n(Y, {
    className: D,
    children: /* @__PURE__ */ n(M, {
      cacheBlockSize: l,
      className: "Custom-Grid",
      defaultColDef: {
        ...G,
        ...d.isNotNil(p) ? p : {}
      },
      headerHeight: 56,
      maxConcurrentDatasourceRequests: 1,
      rowHeight: 80,
      rowModelType: "infinite",
      suppressCellFocus: !0,
      selectionColumnDef: {
        ...L,
        ...d.isNotNil(f) ? f : {}
      },
      getRowId: U,
      loadingOverlayComponent: N,
      noRowsOverlayComponent: I,
      onGridReady: A,
      ...S
    })
  }) : /* @__PURE__ */ n(W, {});
};
export {
  le as default
};
//# sourceMappingURL=ApeironInfinityDataGrid.js.map
